import { useTenantAuth } from '@src/context/auth/useTenantAuth';
import { useClickOutside } from '@src/hooks/useClickOutside';
import { useTenantInAppNotificationPolling } from '@src/hooks/useTenantInAppNotificationPolling';
import { BlackBell } from '@src/ui/elements/icon/bell/BlackBell';
import { TenantInAppNotificationTooltip } from '@src/ui/elements/tooltip/InAppNotificationTooltip';
import { useRef, useState } from 'react';

const CompanyNotificationForTenant = () => {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const tenantAuth = useTenantAuth();
  const { profile } = tenantAuth;

  const { notifications, isExistNewNotification, resetNewNotification } =
    useTenantInAppNotificationPolling(profile?.isLogin ?? false);

  const handleToggle = (e?: React.MouseEvent) => {
    e?.preventDefault();
    setIsOpen((prev) => !prev);
    resetNewNotification();
  };

  useClickOutside([tooltipRef], () => setIsOpen(false));

  return (
    <div
      ref={tooltipRef}
      className='relative'
    >
      <BlackBell
        handleToggle={handleToggle}
        notifications={notifications}
        isExistNewNotification={isExistNewNotification}
      />

      {profile && profile.isLogin && isOpen && (
        <div className='absolute right-5 top-[52px] z-50'>
          <TenantInAppNotificationTooltip
            notifications={notifications}
            onCancel={handleToggle}
          />
        </div>
      )}
    </div>
  );
};

export default CompanyNotificationForTenant;
